export { default } from './PopupWarning';


// WEBPACK FOOTER //
// ./src/components/shared/PopupWarning/index.ts